module.exports = __webpack_public_path__ + "static/img/公司11.b1b44a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公司11.jpg
// module id = 0Uqx
// module chunks = 1